import { createBrowserRouter } from 'react-router-dom'
import { Layout } from '@/components/Layout'
import { RequireAuth } from '@/components/RequireAuth'
import { ROUTES } from '@/constants/routes'
import { AccountCreatedPage } from '@/pages/AccountCreatedPage'
import { AddMemberPage } from '@/pages/AddMemberPage'
import { CguPage } from '@/pages/CguPage'
import { CustomOfferFormPage } from '@/pages/CustomOfferFormPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { DiscoverPage } from '@/pages/DiscoverPage'
import { FaqPage } from '@/pages/FaqPage'
import { Enable2FAPage } from '@/pages/Enable2FAPage'
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage'
import { HomePage } from '@/pages/HomePage'
import { LoginPage } from '@/pages/LoginPage'
import { NotFoundPage } from '@/pages/NotFoundPage'
import { PaymentSuccessPage } from '@/pages/PaymentSuccessPage'
import { ResetPasswordSetPage } from '@/pages/ResetPasswordSetPage'
import { ResetPasswordVerifyCodePage } from '@/pages/ResetPasswordVerifyCodePage'
import { SeatsPage } from '@/pages/SeatsPage'
import { SubscriptionPage } from '@/pages/SubscriptionPage'
import { SubscriptionWizardPage } from '@/pages/SubscriptionWizardPage'
import { Verify2FAPage } from '@/pages/Verify2FAPage'
import { VerifyEmailPage } from '@/pages/VerifyEmailPage'

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: ROUTES.HOME,
        element: <HomePage />,
      },
      {
        path: ROUTES.DISCOVER,
        element: <DiscoverPage />,
      },
      {
        path: ROUTES.DASHBOARD,
        element: <RequireAuth />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: '2fa/enable', element: <Enable2FAPage /> },
        ],
      },
      {
        path: ROUTES.SEATS,
        element: <RequireAuth />,
        children: [
          { index: true, element: <SeatsPage /> },
          { path: 'add', element: <AddMemberPage /> },
        ],
      },
      {
        path: ROUTES.SUBSCRIBE,
        element: <SubscriptionPage />,
      },
      {
        path: ROUTES.SUBSCRIBE_PLAN,
        element: <SubscriptionWizardPage />,
      },
      {
        path: ROUTES.LOGIN,
        element: <LoginPage />,
      },
      {
        path: ROUTES.LOGIN_2FA,
        element: <Verify2FAPage />,
      },
      {
        path: ROUTES.FORGOT_PASSWORD,
        element: <ForgotPasswordPage />,
      },
      {
        path: ROUTES.RESET_PASSWORD_VERIFY,
        element: <ResetPasswordVerifyCodePage />,
      },
      {
        path: ROUTES.RESET_PASSWORD_SET,
        element: <ResetPasswordSetPage />,
      },
      {
        path: ROUTES.ACCOUNT_CREATED,
        element: <AccountCreatedPage />,
      },
      {
        path: ROUTES.VERIFY_EMAIL,
        element: <VerifyEmailPage />,
      },
      {
        path: ROUTES.PAYMENT_SUCCESS,
        element: <PaymentSuccessPage />,
      },
      {
        path: ROUTES.CUSTOM_OFFER_FORM,
        element: <CustomOfferFormPage />,
      },
      {
        path: ROUTES.CGU,
        element: <CguPage />,
      },
      {
        path: ROUTES.FAQ,
        element: <FaqPage />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
])
